const appletProfileIdAction = (payload) => {
  return {
    type: "atual-applet-profile-id",
    payload
  }
}
export default appletProfileIdAction;